document.addEventListener("DOMContentLoaded", function() {
  function initCollectionUI(root) {
    var scope = root || document;

    // 1) Toggle-Button + Grid finden
    var toggleButton =
      scope.querySelector("#toggleGridView") ||
      document.querySelector("#toggleGridView");

    var productGrid =
      scope.querySelector("#product-grid") ||
      scope.querySelector("[data-product-grid]");

    // Früher Exit, wenn nichts Relevantes da ist
    if (!toggleButton || !productGrid) {
      return;
    }

    if (!toggleButton.dataset.bound) {
      toggleButton.dataset.bound = "true";

      var iconGrid1 = toggleButton.querySelector(".icon-grid-1");
      var iconGrid2 = toggleButton.querySelector(".icon-grid-2");

      // Standardansicht: "double-column" aktiv
      productGrid.classList.add("double-column");
      productGrid.classList.remove("single-column");

      toggleButton.addEventListener("click", function() {
        var isDouble = productGrid.classList.contains("double-column");

        productGrid.classList.toggle("double-column", !isDouble);
        productGrid.classList.toggle("single-column", isDouble);

        // Nur SVGs wechseln – kein Text
        if (iconGrid1 && iconGrid2) {
          iconGrid1.style.display = isDouble ? "inline-flex" : "none";
          iconGrid2.style.display = isDouble ? "none" : "inline-flex";
        }
      });
    }

    // 2) Sort-Felder synchron halten
    // WICHTIG: nach AJAX-Updates können die Selects ersetzt werden -> immer neu referenzieren
    var desktopSort     = document.getElementById("SortBy");
    var toolbarSort     = document.getElementById("SortByToolbar");
    var mobilePanelSort = document.getElementById("SortByMobile");

    function syncSort(source, value) {
      if (source !== desktopSort && desktopSort) desktopSort.value = value;
      if (source !== toolbarSort && toolbarSort) toolbarSort.value = value;
      if (source !== mobilePanelSort && mobilePanelSort) mobilePanelSort.value = value;
    }

    function submitClosestForm(el) {
      if (!el) return;
      var form = el.closest("form");

      // Hash entfernen, damit nicht zu #ReadMore o.ä. gesprungen wird
      if (window.location.hash) {
        var cleanUrl = window.location.pathname + window.location.search;
        history.replaceState(null, "", cleanUrl);
      }

      if (!form) return;

      // ✅ FIX: Sort-Bar darf NICHT hart submitten (sonst Reload + Filter weg + sort_by doppelt)
      if (form.id === "FacetFiltersForm-bar") {
        var host = form.closest("facet-filters-form");
        if (host && typeof host.onSubmitHandler === "function") {
          // onSubmitHandler erwartet ein Event-ähnliches Objekt.
          host.onSubmitHandler({
            preventDefault: function() {},
            target: el
          });
          return;
        }

        // Fallback: change event bubblen lassen (facets.js sollte darauf reagieren)
        try {
          el.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (e) {}
        return;
      }

      // Default: andere Forms (falls vorhanden) wie bisher submitten
      form.submit();
    }

    if (desktopSort && !desktopSort.dataset.bound) {
      desktopSort.dataset.bound = "true";
      desktopSort.addEventListener("change", function() {
        // Re-fetch refs (falls DOM ersetzt wurde)
        desktopSort     = document.getElementById("SortBy");
        toolbarSort     = document.getElementById("SortByToolbar");
        mobilePanelSort = document.getElementById("SortByMobile");

        syncSort(desktopSort, desktopSort.value);
        submitClosestForm(desktopSort);
      });
    }

    if (toolbarSort && !toolbarSort.dataset.bound) {
      toolbarSort.dataset.bound = "true";
      toolbarSort.addEventListener("change", function() {
        // Re-fetch refs (falls DOM ersetzt wurde)
        desktopSort     = document.getElementById("SortBy");
        toolbarSort     = document.getElementById("SortByToolbar");
        mobilePanelSort = document.getElementById("SortByMobile");

        syncSort(toolbarSort, toolbarSort.value);
        submitClosestForm(toolbarSort);
      });
    }

    if (mobilePanelSort && !mobilePanelSort.dataset.bound) {
      mobilePanelSort.dataset.bound = "true";
      mobilePanelSort.addEventListener("change", function() {
        // Re-fetch refs (falls DOM ersetzt wurde)
        desktopSort     = document.getElementById("SortBy");
        toolbarSort     = document.getElementById("SortByToolbar");
        mobilePanelSort = document.getElementById("SortByMobile");

        syncSort(mobilePanelSort, mobilePanelSort.value);
        submitClosestForm(mobilePanelSort);
      });
    }

    // 3) Optional: Randomize nur bei Collections (data-randomize="true")
    var grid =
      scope.querySelector("#product-grid") ||
      scope.querySelector("[data-product-grid]");

    if (grid && !grid.dataset.shuffled) {
      var doRandomize = grid.getAttribute("data-randomize") === "true";
      if (doRandomize) {
        var items    = Array.from(grid.children);
        var promos   = [];
        var products = [];

        items.forEach(function(li, idx) {
          if (li.classList && li.classList.contains("promotion-column")) {
            promos.push({ idx: idx, node: li });
          } else {
            products.push(li);
          }
        });

        if (products.length > 1) {
          for (var i = products.length - 1; i > 0; i--) {
            var j   = Math.floor(Math.random() * (i + 1));
            var tmp = products[i];
            products[i] = products[j];
            products[j] = tmp;
          }

          var frag = document.createDocumentFragment();
          var p = 0;
          for (var k = 0; k < items.length; k++) {
            var promo = promos.find(function(x) { return x.idx === k; });
            frag.appendChild(promo ? promo.node : products[p++]);
          }
          grid.innerHTML = "";
          grid.appendChild(frag);
        }
      }
      grid.dataset.shuffled = "true";
    }
  }

  // Initial-Run
  initCollectionUI();

  // Beobachten, wenn Shopify das Grid neu rendert (Filter, Sort, Pagination)
  var container = document.getElementById("ProductGridContainer") || document.body;
  if (container && window.MutationObserver) {
    var observer = new MutationObserver(function() {
      initCollectionUI();
    });
    observer.observe(container, { childList: true, subtree: true });
  }
});
